<template>
  <div class="contend">
    <Layout>
      <Header class="header">
        <div class="logo">
          <img src="../assets/img/logo.png" alt="" />
        </div>
        <div class="userinfo">
          <span style="color:#fff">{{ username }}</span>
          <Dropdown @on-click="userInfo">
            <Avatar size="large" :src="this.$store.state.userInfo.headicon" />
            <DropdownMenu slot="list">
              <DropdownItem name="personal">个人信息</DropdownItem>
              <DropdownItem name="logout">退出登录</DropdownItem>
            </DropdownMenu>
          </Dropdown>
        </div>
      </Header>
      <Layout>
        <Sider hide-trigger :style="{ background: '#fff' }">
          <Menu width="auto" ref="menus" :accordion="true" :active-name="active_name" :open-names="array_name" @on-select="saveActiveName" @on-open-change="openChange">
            <MenuItem name="index" to="/index" ref="index" @click.native="getBreadcrumb()"> <Icon type="ios-home" />&nbsp;主页 </MenuItem>
            <Submenu name="statistics">
              <template slot="title">
                <Icon type="ios-home" />
                统计中心
              </template>
              <MenuItem name="statistics-1" to="/statistics/expStatistics" @click.native="getBreadcrumb()">实验统计</MenuItem>
              <MenuItem name="statistics-2" to="/statistics/stepSum" @click.native="getBreadcrumb()">实验步骤统计</MenuItem>
              <MenuItem name="statistics-3" to="/statistics/checkStatistics" @click.native="getBreadcrumb()">试题考核统计</MenuItem>
              <MenuItem name="statistics-4" to="/statistics/assessStatistics" @click.native="getBreadcrumb()">测评统计</MenuItem>
            </Submenu>

            <Submenu v-for="item in menuData" :name="item.moduleid">
              <template slot="title">
                <Icon type="ios-paper" />
                {{ item.title }}
              </template>

              <MenuItem v-for="subItem in item.children" :to="subItem.path" :name="subItem.moduleid" @click.native="getBreadcrumb()">
                {{ subItem.title }}
              </MenuItem>
            </Submenu>
          </Menu>
        </Sider>
        <Layout :style="{ padding: '0 24px 24px' }">
          <Breadcrumb separator="<b style='color:skyblue'>></b>" :style="{ margin: '12px 0' }">
            <BreadcrumbItem v-for="(item, index) in breadList" :key="index" :to="item.path" @click.native="saveActiveName(item.path)">{{ item.meta.title }}</BreadcrumbItem>
          </Breadcrumb>
          <Content :style="{ minHeight: '280px' }">
            <router-view></router-view>
          </Content>
        </Layout>
      </Layout>
    </Layout>
  </div>
</template>
<script>
import Api from '../api/index'
import _ from 'lodash'

export default {
  data() {
    return {
      breadList: [], // 路由集合
      menuData: [],
      active_name: 'index',
      array_name: ['0'],
      username: ''
    }
  },
  watch: {
    $route() {
      this.getBreadcrumb()
    }
  },
  created() {
    //获取用户信息
    this.GetTokenUser()
    setTimeout(() => {
      this.getBreadcrumb()
      //获取导航数据
      this.getMenuData()
    }, 500)
  },
  mounted() {
    this.$nextTick(() => {
      this.active_name = window.sessionStorage.getItem('active_name') ?? this.active_name
      this.array_name = JSON.parse(window.sessionStorage.getItem('array_name')) ?? this.array_name
      this.$refs.menus.updateActiveName()
    })
  },
  methods: {
    //获取导航菜单
    async getMenuData() {
      const res = await Api.home.getMenu()
      if (!res.success) return this.$router.go(0)
      this.menuData = res.rows

      this.$nextTick(() => {
        this.$refs.menus.updateOpened()
        this.$refs.menus.updateActiveName()
      })
    },
    async GetTokenUser() {
      const res = await Api.home.GetTokenUser()
      this.username = res.rows.username
      if (res.success != false) {
        window.sessionStorage.setItem('userinfo', JSON.stringify(res.rows))
        this.$store.dispatch('setAccount', res.rows)
      } else {
        this.$message.error('获取用户信息失败')
      }
    },
    isHome(route) {
      return route.name === 'index'
    },
    getBreadcrumb() {
      let matched = this.$route.matched
      matched = _.drop(matched)
      //如果不是首页
      if (!this.isHome(matched[0])) {
        matched = [{ path: '/index', meta: { title: '主页' } }].concat(matched)
      }
      this.breadList = matched
    },

    // 用户按钮
    async userInfo(e) {
      if (e == 'logout') {
        const res = await Api.login.logout()
        console.log(res)
        if (res.success != true) return
        localStorage.clear()
        sessionStorage.clear()
        this.$router.push('/')
      } else if (e == 'personal') {
        console.log(e)
        this.$router.push('/userinfo')
      }
    },
    //导航切换
    saveActiveName(name) {
      if (name.indexOf('/') == 0) {
        name = name.slice(1)
      }
      if (name == 'index') {
        window.sessionStorage.setItem('array_name', '["0"]')
        this.$nextTick(() => {
          this.$refs.menus.updateOpened()
          this.$refs.menus.updateActiveName()
        })
      }
      window.sessionStorage.setItem('active_name', name)
      this.active_name = name
    },
    openChange(name) {
      this.array_name = name
      name = JSON.stringify(name)
      window.sessionStorage.setItem('array_name', name)
    }
  }
}
</script>
<style lang="less" scoped>
.contend {
  width: 100%;
  height: 100%;
  > div {
    width: 100%;
    height: 100%;
  }
}
.header {
  display: flex;
  justify-content: space-between;
  background-color: #fff;
  padding: 0 20px;
  border-bottom: 1px solid #3498db;
  .logo {
    height: 100%;
    img {
      height: 45px;
    }
  }
  .userinfo {
    span {
      margin-left: 10px;
    }
  }
}
</style>
